import { PlusIcon } from "@xola/icons";
import { Button } from "@xola/ui-kit";
import React from "react";
import { useHistory } from "react-router-dom";
import { ServerSideTrackingList } from "../../components/ServerSideTracking/ServerSideTrackingList";
import { ResourceListPage } from "../ResourceListPage";

export const TelemetryPage = () => {
    const history = useHistory();
    const handleClick = () => {
        history.push("/marketing/serverSideTracking/modules/create");
    };

    const primaryButton = (
        <Button icon={<PlusIcon />} onClick={handleClick}>
            Create
        </Button>
    );

    return (
        <ResourceListPage
            title="Server Side Tracking"
            breadcrumbItems={[{ text: "Marketing" }, { text: "Server Side Tracking", onClick: handleClick }]}
            primaryButton={primaryButton}
        >
            {(height: number) => <ServerSideTrackingList height={height} />}
        </ResourceListPage>
    );
};
